// config.js
export const BASE_URL = "https://adamo-licenses.ream-850.workers.dev";
export const CONTRACTS_BASE_URL = "https://contracts.ream-850.workers.dev";
export const AUTH_TOKEN = "Bearer b7f3a1d81c2347ab9b52cd19d8e14c87df6f7c4f2ea74bc394c8f3027e38997b";

// RapidAPI Trading Access configuration
export const RAPIDAPI_BASE_URL = "https://tradingview-rest.p.rapidapi.com";
export const RAPIDAPI_KEY = "8b26692a01mshc06d1b118cdc3d0p157164jsnf6764d9e111b";
export const RAPIDAPI_HOST = "tradingview-rest.p.rapidapi.com";

export const HEADERS = {
    "Content-Type": "application/json",
    Authorization: AUTH_TOKEN,
};

export const RAPIDAPI_HEADERS = {
    "Content-Type": "application/json",
    "x-rapidapi-host": RAPIDAPI_HOST,
    "x-rapidapi-key": RAPIDAPI_KEY,
};
